import React from "react";

import { ReportIndicator } from "@common/reportIndicator";
import { HorizontalList } from "@common/horizontalList";
import { ReportIndicators } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function IndicatorsList({ indicators }: Props) {
  return (
    <HorizontalList>
      <div className={styles.indicatorsList}>
        {indicators
          .sort((firstIndicator, secondIndicator) =>
            firstIndicator.name < secondIndicator.name
              ? -1
              : firstIndicator.name > secondIndicator.name
                ? 1
                : 0,
          )
          .map((indicator, index) => (
            <div className={styles.input}>
              <ReportIndicator
                className={styles.indicator}
                value={indicator.value as ReportIndicators}
              />
              <p className={styles.name}>{indicator.name}</p>
            </div>
          ))}
      </div>
    </HorizontalList>
  );
}

export { IndicatorsList };
